import { Action, defaultActions } from '#/common/components/DataGrid';
import { WorkOrderTemplate } from '#/graphql/types';

export const actions: Action<WorkOrderTemplate>[] = [...defaultActions];
